/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import get from "lodash/get";
import { ThemeActionButton, BarLoader, GenericLoader } from "../../../../shared/widgets";
import "../reportView.css";
import Hidden from "@material-ui/core/Hidden";
import { templateStrings } from "../../../../Constant";
import { TableWrapper, PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import {
  passAction,
  runSettlementAction,
  generateDistributionAction,
} from "../../../../redux/action-creators/distanceReportActionCreator";
import { routes } from "../../../../routing/routes";
import { handleDatesChange } from "../../../../shared/utils";
import ButtonToolbarRangePicker from "../../../../shared/components/commonComponents/ButtonToolbarRangePicker";

class PassSettlementReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.passSettlementReportGetList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps && prevProps.cityFilter != this.props.cityFilter)
      || (prevProps && prevProps.operatorFilter != this.props.operatorFilter)
      || (prevProps && prevProps.dateFilter != this.props.dateFilter)
    ) {
      this.passSettlementReportGetList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState({ sortBy: { [key]: value } }, () => {
      this.passSettlementReportGetList();
    });
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.passSettlementReportGetList();
      }
    });
  };

  handleSettlement = (details) => {
    this.props.runSettlement(
      {
        dateFilter: {
          fromDate: new Date(get(details, "fromDate", null)).getTime(),
          toDate: new Date(get(details, "toDate", null)).getTime(),
        },
        cityId: get(details, "props.location.state.cityId", ""),
        agencyId: get(details, "props.location.state.agencyId", ""),
        operatorFilter: this.props.operatorFilter,
      },
      "settlementLoader",
      this.passSettlementReportGetList,
    );
  };

  handleAction = (rowDetails) => {
    if (rowDetails.isUnSettled) return this.handleSettlement(rowDetails);
    this.props.history.push(
      "/report/pass-settlement/residual-settlement",
      rowDetails,
    );
  };

  passSettlementReportGetList = () => {
    this.props.passReportFetched(
      {
        pageNo: this.state.pageNo,
        pageSize: this.state.rowsPerPage,
        dateFilter: this.props.dateFilter,
        cityFilter: this.props.cityFilter,
        operatorFilter: this.props.operatorFilter,
        sortBy: this.state.sortBy,
      },
      "header",
    );
  };

  generateDistribution = (details) => {
    this.props.generateDistribution(
      {
        dateFilter: {
          fromDate: new Date(get(details, "fromDate", null)).getTime(),
          toDate: new Date(get(details, "toDate", null)).getTime(),
        },
      },
      "settlementLoader",
      this.passSettlementReportGetList,
    );
  };

  settlementRowComponent = (rowDetails) => rowDetails.isOldMonth && (
    <>
      {!!rowDetails.isGenerateDistribution && (
        <ThemeActionButton
          onClick={(event) => {
            event.stopPropagation();
            this.generateDistribution(rowDetails);
          }}
          buttonText="Generate Distribution"
        />
      )}
    </>
  );

  render() {
    const {
      headerLoader,
      distaceReportContent,
      distaceReportTotalItems,
      selectedReports,
    } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected,
    } = this.state;
    const templateString = templateStrings.reportPassSettlement;
    templateString.settleUnused.component = this.settlementRowComponent;
    return (
      <div className="pageContainer">
        {!!this.props.settlementLoader && <GenericLoader absolute />}
        {selectedReports === "distance" && (
          <Redirect
            to={{
              pathname: routes.DISTANCE_REPORT,
              state: { from: this.props.location },
            }}
          />
        )}
        <PageWrapper>
          <PageWrapper.Header heading="Pass Settlement" hideS>
            <Hidden only={["sm", "xs"]}>
              <div className="pull-right z-index-10">
                <ButtonToolbarRangePicker
                  handleDatesChange={(dates) => handleDatesChange({ dates, props: this.props })}
                  fromDate={this.props.dateFilter.fromDate}
                  toDate={this.props.dateFilter.toDate}
                />
              </div>
            </Hidden>
          </PageWrapper.Header>
          <BarLoader scope="header" />
          <TableWrapper
            content={!headerLoader && distaceReportContent}
            pageNo={pageNo}
            selected={selected}
            uniqueKey="uniqKey"
            rowsPerPage={rowsPerPage}
            count={distaceReportTotalItems}
            handleChange={this.handleChange}
            templateString={templateString}
            selectionAllowed={false}
            onSortToggle={this.onSortToggle}
            sortBy={sortBy}
            handleAction={this.handleAction}
            handleSettlement={this.handleSettlement}
            actionName="Check Settlement"
            getDisabledStatus={(row) => !row.isCheckDistribution}
          />
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    distaceReportContent:
      (state
        && state.Report
        && state.Report.passData
        && state.Report.passData.data)
      || [],
    distaceReportTotalItems:
      (state
        && state.Report
        && state.Report.passData
        && state.Report.passData.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    settlementLoader:
      state && state.loadingBar && state.loadingBar.settlementLoader,
    cityFilter: state.Cities.selectedCity,
    dateFilter: state.DateFilter.selectedDateFilter,
    selectedReports: state.ReportsType.selectedReportsType,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  runSettlement: (value, loaderScope, callBack) => {
    dispatch(runSettlementAction(value, loaderScope, callBack));
  },
  passReportFetched: (params, loaderScope) => {
    dispatch(passAction(params, loaderScope));
  },
  generateDistribution: (value, loaderScope, callBack) => {
    dispatch(generateDistributionAction(value, loaderScope, callBack));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PassSettlementReport);
